<template>
    <div class="default-checkbox"
         @click="toggleChecked"
         :class="{
             'default-checkbox--checked': checked
         }"
    >
        <div class="default-checkbox__box">
            <div class="default-checkbox__cross">
                <div class="default-checkbox__line default-checkbox__line--1">
                    <div class="default-checkbox__line-inner"></div>
                </div>
                <div class="default-checkbox__line default-checkbox__line--2">
                    <div class="default-checkbox__line-inner"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        id: {
            type: String,
            default: () => ''
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleChecked() {
            this.$emit('change', !this.checked);
        }
    },
    mounted() {
        const label = document.querySelector(`[for="${this.id}"]`);

        if (label) {
            label.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.toggleChecked();
            });
        }
    }
}
</script>

<style scoped lang="scss">
$checkbox-size: 1.5rem;

.default-checkbox {
    display: inline-block;
    cursor: pointer;
}

.default-checkbox__box {
    position: relative;
    background-color: $color-checkbox-gray;
    height: $checkbox-size;
    width: $checkbox-size;
}

.default-checkbox__cross {
    position: absolute;
    top: 0.425 * $checkbox-size;
    left: 0.25 * $checkbox-size;
}

.default-checkbox__line {
    height: 3px;

    &--1 {
        transform: rotate(-45deg);
        transition-delay: .2s;
        width: 0.75 * $checkbox-size;
    }

    &--2 {
        transform: rotate(45deg) translate(-(0.1 * $checkbox-size), (0.0625 * $checkbox-size));
        width: 0.3 * $checkbox-size;
    }
}

.default-checkbox__line-inner {
    background-color: $color-action;
    height: 100%;
    width: 100%;
    transform: scaleX(0);
    transform-origin: 0 0;

    .default-checkbox--checked .default-checkbox__line--1 & {
        transition-delay: .1s;
    }

    .default-checkbox--checked & {
        transition: transform ease-out .1s;
        transform: none;
    }
}
</style>
